import React from 'react'
import CustomTag from 'components/CustomTag'

const DriveStatus = ({ status }) => {
  let colorType
  let tagMessage
  let width
  let padding
  if (status == 'ONGOING' || status == 'RESCHEDULE_REQUESTED') {
    colorType = 'grey'
    tagMessage = status === 'ONGOING' ? 'Ongoing' : 'Rescheduled'
  } else if (status == 'CONFIRMED' || status == 'COMPLETED') {
    colorType = 'green'
    tagMessage = status == 'CONFIRMED' ? 'Confirmed' : 'Completed'
  } else if (status == 'PENDING') {
    colorType = 'orange'
    tagMessage = 'Pending'
  } else if (status === 'CANCELLED') {
    colorType = 'red'
    tagMessage = 'Cancelled'
  } else if (status === 'DRIVE CANCELLED') {
    colorType = 'red'
    tagMessage = 'DRIVE CANCELLED'
    width='125px'
    padding='10px'
    
  }
  else if (status === 'REQUESTED') {
    colorType = 'YellowTag'
    tagMessage = 'Requested'
  }
  return (
    <CustomTag colorType={colorType} message={tagMessage} bordered={false}  width={width}
    padding={padding}
/>
  )
}

export default DriveStatus
